// extracted by mini-css-extract-plugin
module.exports = {"UserNotFound":"UserNotFound_UserNotFound__3MiXx"};